<template>
  <div class="costqa-container">
    <!-- 左侧 -->
    <div class="left-box">
      <div style="display: flex;align-items: center;height: 85px;padding-left: 30px;">
        <img style="width: 20px;margin-right: 15px;" src="@/assets/image/al/wd.png" alt="">
        <div style="font-weight: bold;">造价问答</div>
      </div>
      <div class="left-box-content">
        <div v-if="categories.length === 0" class="loading-text">加载中...</div>
        <div
          v-for="cat in categories"
          :key="cat.id"
          class="left-list-item"
          :class="{ active: activeCategory === cat.id }"
          @click="onCategoryChange(cat.id)"
        >
          {{ cat.title }}
        </div>
      </div>
    </div>

    <!-- 右侧 -->
    <div class="right-box">
      <div class="qa-tabs">
        <div
          v-for="(tab, i) in tabs"
          :key="i"
          class="tab-item"
          :class="{ active: activeTab === tab.value }"
          @click="tabBtn(tab.value)"
        >
          {{ tab.label }}
        </div>
      </div>
      <div class="tab-content">
        <!-- 发布问题 -->
        <div v-if="activeTab === 'publish'">
          <el-form
            ref="publishFormRef"
            :model="publishForm"
            :rules="publishRules"
            label-width="100px"
            label-position="top"
            class="publish-form"
          >
            <el-form-item label="选择分类" prop="category">
              <el-select v-model="publishForm.category" placeholder="请先选择左侧分类" filterable class="form-field-wide" :disabled="subCategories.length === 0">
                <el-option v-for="c in subCategories" :key="c.id" :label="c.title" :value="c.id" />
              </el-select>
              <div v-if="subCategories.length === 0" class="form-tip">请先选择左侧的一级分类</div>
            </el-form-item>

            <el-form-item label="填写标题" prop="title">
              <el-input v-model="publishForm.title" placeholder="请输入您要发布的问题标题" maxlength="60" show-word-limit class="form-field-wide" />
            </el-form-item>

            <el-form-item label="发布问题" prop="content">
              <el-input
                v-model="publishForm.content"
                type="textarea"
                :rows="6"
                placeholder="请输入您要发布的问题"
                class="form-field-wide"
              />
            </el-form-item>

            <el-form-item label="上传问题图片">
              <el-upload
                class="upload-block"
                action="#"
                :http-request="customUpload"
                :on-remove="onFileRemove"
                :on-change="onFileChange"
                :file-list="processedFileList"
                list-type="picture-card"
                :limit="4"
                :before-upload="beforeUpload"
              >
                <img :src="require('@/assets/image/up2.png')" alt="upload" class="upload-placeholder">
              </el-upload>
            </el-form-item>

            <el-form-item label="设置悬赏金额" prop="bounty">
              <el-input v-model.number="publishForm.bounty" placeholder="请输入悬赏的金额" style="width: 240px;">
                <template slot="append">¥</template>
              </el-input>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" class="submit-btn" @click="onSubmit">立即发布</el-button>
            </el-form-item>
          </el-form>
        </div>

        <!-- 问题列表 -->
        <div v-else-if="activeTab === 'list'">
          <!-- 二级分类 -->
          <div class="sub-tabs">
            <div
              v-for="(tab, i) in subCategories"
              :key="i"
              class="sub-tab-item"
              :class="{ active: twoId === tab.id }"
              @click="twoBtn(tab.id)"
            >
              {{ tab.title }}
            </div>
          </div>
          <div v-if="questionList.length > 0"><QAList lxval="1" :show-reply="isCostEngineer" :items="questionList" @select="openDetail" @reply="handleReplyClick" @collect="handleCollect" /></div>
          <div v-else class="empty-state">
            <div class="empty-icon">📝</div>
            <div class="empty-text">暂无问题</div>
          </div>
          <div v-if="total > 0 && questionList.length > 0" style="display:flex; justify-content:flex-end; margin-top: 12px;">
            <el-pagination
              background
              layout="prev, pager, next"
              :total="total"
              :current-page="page"
              :page-size="limit"
              @current-change="onPageChange"
            />
          </div>
        </div>

        <!-- 我的发布 -->
        <div v-else-if="activeTab === 'mypost'">
          <div v-if="questionList.length > 0" class="my-post-list">
            <div v-for="item in questionList" :key="item.id" class="my-post-item" @click="openDetail(item)">
              <div class="post-header">
                <div class="post-title">{{ item.title }}</div>
                <div class="post-category">{{ item.category_name }}</div>
              </div>
              <div class="post-content">{{ item.content }}</div>
              <div v-if="item.images && item.images.length > 0" class="post-images">
                <img
                  v-for="(image, index) in item.images"
                  :key="index"
                  :src="getImageUrl(image)"
                  alt="图片"
                  class="post-image"
                >
              </div>
              <div class="post-footer">
                <div class="post-meta">
                  <span class="reward-amount">悬赏：¥{{ item.reward_amount }}</span>
                  <span class="answer-count">{{ item.answer_count }}个回答</span>
                </div>
                <div class="post-actions">
                  <span class="view-detail">查看详情 ></span>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="empty-state">
            <div class="empty-icon">📝</div>
            <div class="empty-text">暂无发布的问题</div>
          </div>
          <div v-if="total > 0 && questionList.length > 0" style="display:flex; justify-content:flex-end; margin-top: 12px;">
            <el-pagination
              background
              layout="prev, pager, next"
              :total="total"
              :current-page="page"
              :page-size="limit"
              @current-change="onPageChange"
            />
          </div>
        </div>

        <!-- 我的问答 -->
        <div v-else-if="activeTab === 'myanswer'">
          <div class="my-tabs">
            <div
              v-for="t in myAnswerTabs"
              :key="t.value"
              class="my-tab-item"
              :class="{ active: activeMyAnswerTab === t.value }"
              @click="onMyAnswerTabChange(t.value)"
            >
              {{ t.label }}
            </div>
          </div>
          <div class="my-tab-content">
            <!-- 已回答 -->
            <div v-if="activeMyAnswerTab === 'answered'">
              <div v-if="questionList.length > 0" class="my-answers-list">
                <div v-for="item in questionList" :key="item.id" class="answer-item-card">
                  <div class="answer-card-header">
                    <div class="question-title">{{ item.question_title }}</div>
                    <div class="adopt-status" :class="{ adopted: item.is_adopted === 1 }">
                      {{ item.is_adopted === 1 ? '已采纳' : '未采纳' }}
                    </div>
                  </div>
                  <div class="answer-content">{{ item.content }}</div>
                  <div v-if="item.images && item.images.length > 0" class="answer-images">
                    <img
                      v-for="(img, index) in item.images"
                      :key="index"
                      :src="getImageUrl(img)"
                      alt="回答图片"
                      class="answer-image"
                    >
                  </div>
                  <div class="answer-footer">
                    <div class="answer-info">
                      <span class="reward-amount">悬赏：¥{{ item.reward_amount }}</span>
                      <span class="like-count">点赞：{{ item.like_count }}</span>
                    </div>
                    <div class="question-user">提问者：{{ item.question_user_nickname }}</div>
                  </div>
                </div>
              </div>
              <div v-else class="empty-state">
                <div class="empty-icon">💬</div>
                <div class="empty-text">暂无已回答的问题</div>
              </div>
            </div>

            <!-- 问答收入 -->
            <div v-else-if="activeMyAnswerTab === 'income'">
              <div class="income-card">
                <div class="income-title">问答收入</div>
                <div class="income-total">¥{{ incomeTotal }}</div>
              </div>
              <div class="income-list-wrap">
                <div class="income-list-title">收入记录</div>
                <div v-if="incomeRecords.length > 0" class="income-list">
                  <div v-for="record in incomeRecords" :key="record.id" class="income-item">
                    <div class="income-left">
                      <div class="income-name">{{ record.description }}</div>
                      <div class="income-question">问题：{{ record.question_title }}</div>
                      <div class="income-time">{{ record.createtime }}</div>
                    </div>
                    <div class="income-amount">+{{ record.amount }}</div>
                  </div>
                </div>
                <div v-else class="empty-state">
                  <div class="empty-icon">💰</div>
                  <div class="empty-text">暂无收入记录</div>
                </div>
                <div v-if="incomeTotalCount > 0 && incomeRecords.length > 0" style="display:flex; justify-content:flex-end; margin-top: 12px;">
                  <el-pagination
                    background
                    layout="prev, pager, next"
                    :total="incomeTotalCount"
                    :current-page="incomePage"
                    :page-size="incomeLimit"
                    @current-change="onIncomePageChange"
                  />
                </div>
              </div>
            </div>

            <!-- 历史记录 -->
            <div v-else>
              <div v-if="historyList.length > 0" class="history-list">
                <div v-for="item in historyList" :key="item.id" class="history-item">
                  <div class="history-content">
                    <div class="history-title">{{ item.title }}</div>
                    <div class="history-meta">
                      <span class="history-type">{{ item.type === 'answer' ? '回答' : '问题' }}</span>
                      <span class="history-status" :class="{ adopted: item.is_adopted === 1 }">
                        {{ item.is_adopted === 1 ? '已采纳' : '未采纳' }}
                      </span>
                    </div>
                    <div class="history-time">{{ item.createtime }}</div>
                  </div>
                </div>
              </div>
              <div v-else class="empty-state">
                <div class="empty-icon">📋</div>
                <div class="empty-text">暂无历史记录</div>
              </div>
              <div v-if="historyTotal > 0 && historyList.length > 0" style="display:flex; justify-content:flex-end; margin-top: 12px;">
                <el-pagination
                  background
                  layout="prev, pager, next"
                  :total="historyTotal"
                  :current-page="historyPage"
                  :page-size="historyLimit"
                  @current-change="onHistoryPageChange"
                />
              </div>
            </div>
          </div>
        </div>
        <div v-else>本地服务区域</div>
      </div>

      <!-- 详情 -->
      <el-dialog :visible.sync="detailVisible" custom-class="responsive-dialog-wide" width="780px" top="5vh" :close-on-click-modal="false">
        <div v-if="currentDetail" class="detail-body">
          <div class="detail-title">{{ currentDetail.title }}</div>
          <div class="detail-section">
            <div class="section-title">问题描述</div>
            <div style="font-size: 16px;color: #333;margin-bottom: 10px;">{{ currentDetail.content }}</div>
            <div v-if="currentDetail.images && currentDetail.images.length" class="detail-images">
              <img
                v-for="(img, index) in currentDetail.images"
                :key="'q-img-' + index"
                :src="img"
                alt="图片"
                class="detail-image-thumb"
                @click="previewImage(img)"
              >
            </div>
            <div class="section-title" style="margin-top: 14px;">问题回答</div>
            <div v-if="currentDetail.answers && currentDetail.answers.length">
              <div v-for="a in currentDetail.answers" :key="a.id" class="answer-item">
                <div style="font-size: 16px;color: #333;margin-bottom: 10px;">{{ a.content }}</div>
                <div v-if="a.images && a.images.length" class="detail-images">
                  <img
                    v-for="(img, index) in a.images"
                    :key="'a-img-' + a.id + '-' + index"
                    :src="img"
                    alt="回答图片"
                    class="detail-image-thumb"
                    @click="previewImage(img)"
                  >
                </div>
                <div style="display: flex; align-items: center; justify-content: space-between;">
                  <div class="answer-user">
                    <img class="answer-avatar" :src="a.avatar" alt="头像">
                    <span class="answer-name">{{ a.name }}</span>
                  </div>
                  <div class="answer-actions">
                    <span
                      v-if="isQuestionOwner"
                      class="followup-reply"
                      @click="showFollowupDialog(a.id)"
                    >
                      <img :src="huifuIcon" class="action-icon" alt="">
                      回复
                    </span>
                    <span v-if="isQuestionOwner" class="adopt" :class="{ active: a.is_adopted }" @click="adoptedBtn(a.id)">
                      <img :src="a.is_adopted ? zany2Icon : zany1Icon" class="action-icon">
                      采纳
                    </span>
                    <!-- <span class="adopt" :class="{ active: a.is_adopted }">
                      <img :src="a.is_adopted ? zann2Icon : zann1Icon" class="action-icon">
                      不采纳
                    </span> -->
                  </div>
                </div>
                <div v-if="a.followups && a.followups.length" class="followup-list">
                  <div v-for="f in a.followups" :key="f.id" class="followup-item">
                    <div class="followup-header">
                      <div class="followup-tag">{{ f.reply_type_text || '追问' }}</div>
                      <div v-if="f.name" class="followup-user">
                        <img class="followup-avatar" :src="f.avatar" alt="头像">
                        <span>{{ f.name }}</span>
                        <span v-if="f.to_nickname" class="followup-to">@{{ f.to_nickname }}</span>
                      </div>
                    </div>
                    <div class="followup-content">{{ f.content }}</div>
                    <div v-if="f.images && f.images.length" class="detail-images">
                      <img
                        v-for="(img, fIdx) in f.images"
                        :key="'f-img-' + f.id + '-' + fIdx"
                        :src="img"
                        alt="追问图片"
                        class="detail-image-thumb"
                        @click="previewImage(img)"
                      >
                    </div>
                    <div v-if="f.reply && f.reply.content" class="followup-reply-block">
                      <div class="followup-header">
                        <div class="followup-tag reply">{{ f.reply.reply_type_text || '追问回复' }}</div>
                        <div v-if="f.reply.name" class="followup-user">
                          <img class="followup-avatar" :src="f.reply.avatar" alt="头像">
                          <span>{{ f.reply.name }}</span>
                          <span v-if="f.reply.to_nickname" class="followup-to">@{{ f.reply.to_nickname }}</span>
                        </div>
                      </div>
                      <div class="followup-content">{{ f.reply.content }}</div>
                      <div v-if="f.reply.images && f.reply.images.length" class="detail-images">
                        <img
                          v-for="(img, rIdx) in f.reply.images"
                          :key="'fr-img-' + f.id + '-' + rIdx"
                          :src="img"
                          alt="追问回复图片"
                          class="detail-image-thumb"
                          @click="previewImage(img)"
                        >
                      </div>
                    </div>
                    <div v-if="isCostEngineer && !f.has_reply" class="followup-actions">
                      <span class="followup-reply" @click="showFollowupReplyDialog(f.id)">
                        <img :src="huifuIcon" class="action-icon" alt="">
                        回复追问
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="loading-text">暂无回答</div>
          </div>
          <div v-if="currentDetail.lxval == '1' && isCostEngineer" class="reply-section">
            <el-button type="primary" @click="showReplyDialog">回复问题</el-button>
          </div>
        </div>
      </el-dialog>

      <!-- 图片预览 -->
      <div v-if="showImagePreview" class="image-preview-mask" @click="closeImagePreview">
        <div class="image-preview-container" @click.stop>
          <img :src="previewImageUrl" alt="预览图片" class="preview-image">
          <img
            src="@/assets/image/al/close.png"
            alt="关闭"
            class="preview-close"
            @click="closeImagePreview"
          >
        </div>
      </div>

      <!-- 追问 / 回复追问弹窗 -->
      <el-dialog :visible.sync="followupVisible" custom-class="responsive-dialog-medium" width="640px" top="10vh" :close-on-click-modal="false" :title="followupDialogMode === 'reply' ? '回复追问' : '追问回答'">
        <el-form
          ref="followupFormRef"
          :model="followupForm"
          :rules="followupRules"
          label-width="80px"
          label-position="top"
        >
          <el-form-item label="回复内容" prop="content">
            <el-input
              v-model="followupForm.content"
              type="textarea"
              :rows="6"
              maxlength="500"
              show-word-limit
              :placeholder="followupDialogMode === 'reply' ? '请输入您对这条追问的回复' : '请输入您对这条回答的追问'"
            />
          </el-form-item>
          <el-form-item label="回复图片（选填）">
            <el-upload
              class="reply-upload-images"
              action="#"
              :http-request="followupImageUpload"
              :on-remove="onFollowupImageRemove"
              :on-change="onFollowupImageChange"
              :file-list="processedFollowupImageList"
              list-type="picture-card"
              :limit="9"
              :before-upload="beforeUpload"
            >
              <img :src="require('@/assets/image/up2.png')" alt="upload" class="upload-placeholder">
            </el-upload>
            <div class="form-tip">最多 9 张，多张图将以英文逗号拼接提交</div>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="followupVisible = false">取消</el-button>
          <el-button type="primary" :loading="followupLoading" @click="submitFollowup">{{ followupDialogMode === 'reply' ? '确认回复' : '提交追问' }}</el-button>
        </div>
      </el-dialog>

      <!-- 造价师回复问题弹窗 -->
      <el-dialog :visible.sync="replyVisible" custom-class="responsive-dialog-medium" width="640px" top="10vh" :close-on-click-modal="false" title="回复问题">
        <el-form
          ref="replyFormRef"
          :model="replyForm"
          :rules="replyRules"
          label-width="80px"
          label-position="top"
        >
          <el-form-item label="回复内容" prop="content">
            <el-input
              v-model="replyForm.content"
              type="textarea"
              :rows="6"
              maxlength="500"
              show-word-limit
              placeholder="请输入您的回复内容"
            />
          </el-form-item>
          <el-form-item label="回复图片（选填）">
            <el-upload
              class="reply-upload-images"
              action="#"
              :http-request="replyImageUpload"
              :on-remove="onReplyImageRemove"
              :on-change="onReplyImageChange"
              :file-list="processedReplyImageList"
              list-type="picture-card"
              :limit="9"
              :before-upload="beforeUpload"
            >
              <img :src="require('@/assets/image/up2.png')" alt="upload" class="upload-placeholder">
            </el-upload>
            <div class="form-tip">最多 9 张，多张图将以英文逗号拼接提交</div>
          </el-form-item>
          <el-form-item label="附件（选填）">
            <el-upload
              class="reply-upload-file"
              action="#"
              :http-request="replyAttachmentUpload"
              :before-upload="beforeReplyAttachment"
              :on-change="onReplyAttachmentChange"
              :on-remove="onReplyAttachmentRemove"
              :file-list="replyAttachmentFileList"
              :limit="1"
              :on-exceed="onReplyAttachmentExceed"
            >
              <el-button size="small" type="primary">选择文件</el-button>
              <div slot="tip" class="el-upload__tip">仅可上传 1 个附件，提交时传单个 file 字段（先上传再传 URL）</div>
            </el-upload>
          </el-form-item>
        </el-form>

        <div slot="footer" class="dialog-footer">
          <el-button @click="replyVisible = false">取消</el-button>
          <el-button type="primary" :loading="replyLoading" @click="submitReply">确认回复</el-button>
        </div>
      </el-dialog>
    </div>
  </div>

</template>
<script>
import { mapGetters } from 'vuex'
import { getQACategoryList, getQuestionList, getQuestionDetail, postQuestion, uploadImage, answerQuestion, getMyQuestions, adoptAnswer, askFollowup, replyFollowup, getMyAnswers, getQAIncome, getHistory, addFavorite, cancelFavorite } from '@/api/user'
import { checkAuth, getUserInfo, getToken } from '@/utils/auth'

export default {
  name: 'CostQA',
  components: {
    QAList: () => import('./components/QAList.vue')
  },
  data() {
    return {
      categories: [],
      subCategories: [],
      twoId: '',
      activeCategory: null,
      tabs: [
        { label: '问题列表', value: 'list' },
        { label: '发布问题', value: 'publish' }
        // { label: '我的发布', value: 'mypost' },
        // { label: '我的回答', value: 'myanswer' }
      ],
      activeTab: 'list',
      myAnswerTabs: [
        { label: '已回答', value: 'answered' },
        { label: '问答收入', value: 'income' },
        { label: '历史记录', value: 'history' }
      ],
      activeMyAnswerTab: 'answered',
      // 问答收入相关数据
      incomeTotal: 0,
      incomeRecords: [],
      incomePage: 1,
      incomeLimit: 10,
      incomeTotalCount: 0,
      // 历史记录相关数据
      historyList: [],
      historyPage: 1,
      historyLimit: 10,
      historyTotal: 0,
      publishForm: {
        category: null,
        title: '',
        content: '',
        bounty: null
      },
      images: [],
      publishRules: {
        category: [{ required: true, message: '请选择分类', trigger: 'change' }],
        title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        content: [{ required: true, message: '请输入问题描述', trigger: 'blur' }],
        bounty: [
          { required: true, message: '请输入悬赏金额', trigger: 'blur' },
          { type: 'number', message: '金额需为数字', trigger: 'blur' }
        ]
      },
      fileList: [],
      huifuIcon: require('@/assets/image/al/huifu.png'),
      zany1Icon: require('@/assets/image/al/zany1.png'),
      zany2Icon: require('@/assets/image/al/zany2.png'),
      zann1Icon: require('@/assets/image/al/zann1.png'),
      zann2Icon: require('@/assets/image/al/zann2.png'),
      questionList: [],
      page: 1,
      limit: 10,
      total: 0,
      detailVisible: false,
      currentDetail: null,
      adopted: false,
      // 回复相关
      replyVisible: false,
      replyLoading: false,
      defaultAvatar: require('@/assets/image/logo.png'),
      replyForm: {
        content: ''
      },
      replyRules: {
        content: [{ required: true, message: '请输入回复内容', trigger: 'blur' }]
      },
      replyImageFileList: [],
      replyImageUrls: [],
      replyAttachmentFileList: [],
      replyAttachmentUrl: '',
      showImagePreview: false,
      previewImageUrl: '',
      // 追问：ask=提问人追问回答，reply=造价师回复追问
      followupVisible: false,
      followupLoading: false,
      followupDialogMode: 'ask',
      followupAnswerId: null,
      followupReplyId: null,
      followupForm: {
        content: ''
      },
      followupRules: {
        content: [{ required: true, message: '请输入回复内容', trigger: 'blur' }]
      },
      followupImageFileList: [],
      followupImageUrls: []
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    // 合并本地缓存与 Vuex（登录接口与 getProfile 字段可能不一致）
    mergedUserProfile() {
      const cached = getUserInfo() || {}
      const store = this.userInfo && typeof this.userInfo === 'object' ? this.userInfo : {}
      return { ...cached, ...store }
    },
    isCostEngineer() {
      const u = this.mergedUserProfile
      const raw = u.group_id != null && u.group_id !== '' ? u.group_id : u.groupId
      const gid = Number(raw)
      if (gid === 2) return true
      if (raw === 2 || raw === '2') return true
      const t = String(u.user_type || '')
      return t.indexOf('造价师') !== -1
    },
    // 处理文件列表，预览使用全路径
    processedFileList() {
      return this.fileList.map(item => {
        if (item.status === 'success' && item.response) {
          return {
            ...item,
            url: item.response.fullurl || item.response.url || item.url
          }
        }
        return item
      })
    },
    processedReplyImageList() {
      return this.replyImageFileList.map(item => {
        if (item.status === 'success' && item.response) {
          return {
            ...item,
            url: item.response.fullurl || item.response.url || item.url
          }
        }
        return item
      })
    },
    processedFollowupImageList() {
      return this.followupImageFileList.map(item => {
        if (item.status === 'success' && item.response) {
          return {
            ...item,
            url: item.response.fullurl || item.response.url || item.url
          }
        }
        return item
      })
    },
    isQuestionOwner() {
      if (!this.currentDetail || this.currentDetail.user_id == null) return false
      const u = this.mergedUserProfile
      const uid = u.id != null ? u.id : u.user_id
      if (uid == null) return false
      return String(uid) === String(this.currentDetail.user_id)
    }
  },
  watch: {
    '$route'(to) {
      if (to.path === '/costqa/index') {
        this.applyRouteTabQuery()
      }
    }
  },
  created() {
    this.fetchCategories()
  },
  mounted() {
    this.applyRouteTabQuery()
    this.syncUserInfoForRole()
  },
  methods: {
    async syncUserInfoForRole() {
      if (!getToken()) return
      try {
        await this.$store.dispatch('user/getInfo')
      } catch (e) {
        // 忽略：仍可用 mergedUserProfile 中的 localStorage
      }
    },
    applyRouteTabQuery() {
      const tab = this.$route.query && this.$route.query.tab
      if (tab === 'publish') {
        this.tabBtn('publish')
      }
    },
    tabBtn(tab) {
      this.activeTab = tab
      if (tab === 'list') {
        // 切到问题列表时，如未选二级分类则默认第一个，并拉取数据
        if (!this.twoId && this.subCategories && this.subCategories.length > 0) {
          this.twoId = this.subCategories[0].id
        }
        this.page = 1
        this.fetchQuestionList()
      } else if (tab === 'mypost') {
        // 切到我的发布时，拉取我的问题列表
        this.page = 1
        this.fetchMyQuestions()
      } else if (tab === 'myanswer') {
        // 切到我的回答时，拉取我的回答列表
        this.page = 1
        this.activeMyAnswerTab = 'answered'
        this.fetchMyAnswers()
      }
    },
    twoBtn(tab) {
      if (this.twoId === tab) return
      this.twoId = tab
      this.page = 1
      this.fetchQuestionList()
    },
    async fetchCategories() {
      try {
        const response = await getQACategoryList()
        if (response && response.code === 1 && response.data) {
          this.categories = response.data
          // 默认选择第一个分类
          if (this.categories.length > 0) {
            this.activeCategory = this.categories[0].id
            this.subCategories = this.categories[0].children || []
            this.twoId = this.subCategories && this.subCategories.length ? this.subCategories[0].id : ''
            if (this.activeTab === 'list' && this.twoId) {
              this.page = 1
              this.fetchQuestionList()
            }
          }
        }
      } catch (error) {
        console.error('获取分类列表失败:', error)
        this.$message && this.$message.error('获取分类列表失败')
      }
    },
    onCategoryChange(categoryId) {
      this.activeCategory = categoryId
      const selectedCategory = this.categories.find(cat => cat.id === categoryId)
      this.subCategories = selectedCategory ? selectedCategory.children || [] : []
      this.twoId = this.subCategories && this.subCategories.length ? this.subCategories[0].id : ''
      if (this.activeTab === 'list' && this.twoId) {
        this.page = 1
        this.fetchQuestionList()
      }
    },
    async fetchQuestionList() {
      if (!this.twoId) {
        this.questionList = []
        this.total = 0
        return
      }
      try {
        const res = await getQuestionList({ page: this.page, limit: this.limit, category_id: this.twoId })
        if (res && res.code === 1 && res.data) {
          const list = Array.isArray(res.data.list) ? res.data.list : []
          this.total = Number(res.data.total || 0)
          // 字段映射到 QAList 结构
          this.questionList = list.map(item => {
            const rawImages = item.images
            let cover = null
            if (Array.isArray(rawImages) && rawImages.length > 0) {
              cover = rawImages[0]
            } else if (typeof rawImages === 'string' && rawImages) {
              const parts = rawImages.split(',').map(s => s.trim()).filter(Boolean)
              cover = parts.length ? parts[0] : null
            }
            const image = cover && this.$getImageUrl ? this.$getImageUrl(cover) : cover || null

            return {
              id: item.id,
              title: item.title,
              content: item.content,
              image,
              bounty: item.reward_amount,
              answerCount: item.answer_count,
              name: item.nickname,
              avatar: this.$getImageUrl ? this.$getImageUrl(item.avatar) : item.avatar,
              category: item.category_name,
              time: '',
              type: 1,
              is_collected: item.is_collected || false
            }
          })
        } else {
          this.questionList = []
          this.total = 0
        }
      } catch (e) {
        console.error('获取问题列表失败:', e)
        this.questionList = []
        this.total = 0
      }
    },
    // 获取我的问题列表
    async fetchMyQuestions() {
      try {
        const res = await getMyQuestions({ page: this.page, limit: this.limit })
        if (res && res.code === 1 && res.data) {
          const list = Array.isArray(res.data.list) ? res.data.list : []
          this.total = Number(res.data.total || 0)
          // 直接使用接口返回的原始数据结构
          this.questionList = list
        } else {
          this.questionList = []
          this.total = 0
        }
      } catch (e) {
        console.error('获取我的问题列表失败:', e)
        this.questionList = []
        this.total = 0
      }
    },
    // 我的回答标签切换
    onMyAnswerTabChange(tab) {
      this.activeMyAnswerTab = tab
      this.page = 1
      if (tab === 'answered') {
        this.fetchMyAnswers()
      } else if (tab === 'income') {
        this.incomePage = 1
        this.fetchQAIncome()
      } else if (tab === 'history') {
        this.historyPage = 1
        this.fetchHistory()
      }
    },
    // 获取我的回答列表
    async fetchMyAnswers() {
      try {
        const res = await getMyAnswers({
          type: 'answered',
          page: this.page,
          limit: this.limit
        })
        if (res && res.code === 1 && res.data) {
          const list = Array.isArray(res.data.list) ? res.data.list : []
          this.total = Number(res.data.total || 0)
          // 字段映射 - 根据我的回答接口数据结构
          this.questionList = list.map(item => {
            return {
              id: item.id,
              question_title: item.question_title, // 问题标题
              content: item.content, // 回答内容
              images: item.images || [], // 回答图片数组
              is_adopted: item.is_adopted, // 是否被采纳
              like_count: item.like_count, // 点赞数
              reward_amount: item.reward_amount, // 悬赏金额
              question_user_nickname: item.question_user_nickname, // 提问者昵称
              answer_user_nickname: item.answer_user_nickname // 回答者昵称
            }
          })
        } else {
          this.questionList = []
          this.total = 0
        }
      } catch (e) {
        console.error('获取我的回答列表失败:', e)
        this.questionList = []
        this.total = 0
      }
    },
    // 获取问答收入
    async fetchQAIncome() {
      try {
        const res = await getQAIncome({
          page: this.incomePage,
          limit: this.incomeLimit
        })
        if (res && res.code === 1 && res.data) {
          this.incomeTotal = res.data.total_income || 0
          this.incomeRecords = res.data.records || []
          this.incomeTotalCount = res.data.total || 0
        } else {
          this.incomeTotal = 0
          this.incomeRecords = []
          this.incomeTotalCount = 0
        }
      } catch (e) {
        console.error('获取问答收入失败:', e)
        this.incomeTotal = 0
        this.incomeRecords = []
        this.incomeTotalCount = 0
      }
    },
    // 获取历史记录
    async fetchHistory() {
      try {
        const res = await getHistory({
          page: this.historyPage,
          limit: this.historyLimit
        })
        if (res && res.code === 1 && res.data) {
          const list = Array.isArray(res.data.list) ? res.data.list : []
          this.historyTotal = list.length // 使用列表长度作为总数
          this.historyList = list.map(item => {
            return {
              id: item.id,
              title: item.title,
              is_adopted: item.is_adopted,
              createtime: this.formatTime(item.createtime),
              type: item.type
            }
          })
        } else {
          this.historyList = []
          this.historyTotal = 0
        }
      } catch (e) {
        console.error('获取历史记录失败:', e)
        this.historyList = []
        this.historyTotal = 0
      }
    },
    // 历史记录分页切换
    onHistoryPageChange(p) {
      this.historyPage = p
      this.fetchHistory()
    },
    // 问答收入分页切换
    onIncomePageChange(p) {
      this.incomePage = p
      this.fetchQAIncome()
    },
    onPageChange(p) {
      this.page = p
      if (this.activeTab === 'list') {
        this.fetchQuestionList()
      } else if (this.activeTab === 'mypost') {
        this.fetchMyQuestions()
      } else if (this.activeTab === 'myanswer') {
        this.fetchMyAnswers()
      }
    },
    onPageSizeChange(size) {
      this.limit = size
      this.page = 1
      if (this.activeTab === 'list') {
        this.fetchQuestionList()
      } else if (this.activeTab === 'mypost') {
        this.fetchMyQuestions()
      } else if (this.activeTab === 'myanswer') {
        this.fetchMyAnswers()
      }
    },
    beforeUpload(file) {
      // 检查文件类型
      const isImage = file.type.startsWith('image/')
      if (!isImage) {
        this.$message.error('只能上传图片文件!')
        return false
      }
      // 检查文件大小 (5MB)
      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isLt5M) {
        this.$message.error('图片大小不能超过 5MB!')
        return false
      }
      return true
    },
    async customUpload(file) {
      try {
        const response = await uploadImage(file.file)
        if (response && response.code === 1) {
          // 上传成功，返回完整数据用于预览和提交
          return response.data
        } else {
          this.$message.error(response?.msg || '上传失败')
          return false
        }
      } catch (error) {
        console.error('上传图片失败:', error)
        this.$message.error('上传失败，请重试')
        return false
      }
    },
    async replyImageUpload(file) {
      return this.customUpload(file)
    },
    onReplyImageChange(file, fileList) {
      this.replyImageFileList = fileList
      this.replyImageUrls = fileList
        .filter(item => item.status === 'success')
        .map(item => {
          const response = item.response
          if (response && response.url) return response.url
          return item.url
        })
        .filter(Boolean)
    },
    onReplyImageRemove(file, fileList) {
      this.replyImageFileList = fileList
      this.replyImageUrls = fileList
        .filter(item => item.status === 'success')
        .map(item => {
          const response = item.response
          if (response && response.url) return response.url
          return item.url
        })
        .filter(Boolean)
    },
    beforeReplyAttachment(file) {
      const name = (file.name || '').toLowerCase()
      const ext = name.includes('.') ? name.split('.').pop() : ''
      const allow = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'zip', 'rar', 'txt', 'dwg']
      if (!ext || !allow.includes(ext)) {
        this.$message.error('仅支持 pdf、word、excel、zip、rar、txt、dwg 等格式')
        return false
      }
      const maxMb = 15
      if (file.size / 1024 / 1024 > maxMb) {
        this.$message.error(`附件大小不能超过 ${maxMb}MB`)
        return false
      }
      return true
    },
    async replyAttachmentUpload(opt) {
      const rawFile = opt.file
      try {
        const response = await uploadImage(rawFile)
        if (response && response.code === 1) {
          const d = response.data
          opt.onSuccess(d, rawFile)
        } else {
          this.$message.error(response?.msg || '附件上传失败')
          opt.onError(new Error('upload fail'))
        }
      } catch (e) {
        console.error(e)
        this.$message.error('附件上传失败，请重试')
        opt.onError(e)
      }
    },
    onReplyAttachmentChange(file, fileList) {
      this.replyAttachmentFileList = fileList
      const done = fileList.filter(f => f.status === 'success' && f.response)
      if (done.length) {
        const d = done[done.length - 1].response
        this.replyAttachmentUrl = typeof d === 'string' ? d : (d && (d.url || d.fullurl)) || ''
      } else if (!fileList.length) {
        this.replyAttachmentUrl = ''
      }
    },
    onReplyAttachmentRemove() {
      this.replyAttachmentFileList = []
      this.replyAttachmentUrl = ''
    },
    onReplyAttachmentExceed() {
      this.$message.warning('仅可上传 1 个附件')
    },
    onFileChange(file, fileList) {
      this.fileList = fileList
      // 提取半路径URL用于提交接口
      this.images = fileList
        .filter(item => item.status === 'success')
        .map(item => {
          const response = item.response
          if (response && response.url) {
            return response.url // 使用半路径
          }
          return item.url
        })
        .filter(Boolean)
    },
    onFileRemove(file, fileList) {
      this.fileList = fileList
      // 更新图片数组（使用半路径）
      this.images = fileList
        .filter(item => item.status === 'success')
        .map(item => {
          const response = item.response
          if (response && response.url) {
            return response.url // 使用半路径
          }
          return item.url
        })
        .filter(Boolean)
    },
    async onSubmit() {
      // 检查登录状态
      if (!checkAuth(this.$router, '请先登录后再发布问题')) {
        return
      }
      this.$refs.publishFormRef.validate(async(valid) => {
        if (!valid) return

        try {
          const imagesStr = Array.isArray(this.images) ? this.images.join(',') : (this.images || '')
          const data = {
            category_id: this.publishForm.category,
            title: this.publishForm.title,
            content: this.publishForm.content,
            images: imagesStr, // 后端要求为字符串
            reward_amount: this.publishForm.bounty,
            province: '',
            city: ''
          }

          const response = await postQuestion(data)
          if (response && response.code === 1) {
            this.$message.success('发布成功')
            // 重置表单
            this.resetForm()
          } else {
            this.$message.error(response?.msg || '发布失败')
          }
        } catch (error) {
          console.error('发布问题失败:', error)
        }
      })
    },
    resetForm() {
      this.publishForm = {
        category: null,
        title: '',
        content: '',
        bounty: null
      }
      this.fileList = []
      this.images = []
      this.$refs.publishFormRef.resetFields()
    },
    async openDetail(q) {
      this.detailVisible = true
      const sourceType = q && q.lxval ? q.lxval : '1'
      await this.fetchQuestionDetail(q.id, sourceType)
    },
    async fetchQuestionDetail(question_id, lxval = '1') {
      try {
        const res = await getQuestionDetail(question_id)
        if (res && res.code === 1 && res.data) {
          const d = res.data
          const questionImages = this.parseImageList(d.images)
          const image = questionImages.length ? questionImages[0] : null
          const avatar = d.avatar ? (this.$getImageUrl ? this.$getImageUrl(d.avatar) : d.avatar) : this.defaultAvatar
          const answers = Array.isArray(d.answers) ? d.answers.map(a => ({
            id: a.id,
            content: a.content,
            images: this.parseImageList(a.images),
            is_adopted: Number(a.is_adopted) === 1,
            like_count: a.like_count || 0,
            name: a.nickname || '匿名用户',
            avatar: a.avatar ? (this.$getImageUrl ? this.$getImageUrl(a.avatar) : a.avatar) : this.defaultAvatar,
            followups: this.mapAnswerFollowups(a)
          })) : []

          this.currentDetail = {
            id: d.id,
            user_id: d.user_id,
            title: d.title,
            content: d.content,
            image,
            images: questionImages,
            bounty: d.reward_amount,
            answerCount: d.answer_count,
            name: d.nickname,
            avatar,
            category: d.category_name,
            time: '',
            answers,
            lxval
          }
        } else {
          this.currentDetail = null
        }
      } catch (e) {
        console.error('获取问题详情失败:', e)
        this.currentDetail = null
      }
    },
    toggleAdopt(isAdopt) {
      this.adopted = isAdopt
    },
    // 获取图片URL
    getImageUrl(imagePath) {
      return this.$getImageUrl ? this.$getImageUrl(imagePath) : imagePath
    },
    resolveDetailAvatar(avatar) {
      return avatar ? (this.$getImageUrl ? this.$getImageUrl(avatar) : avatar) : this.defaultAvatar
    },
    pickFollowupReply(followup) {
      if (!followup) return null
      if (followup.reply || followup.followup_reply) {
        return followup.reply || followup.followup_reply
      }
      const children = Array.isArray(followup.children) ? followup.children : []
      if (!children.length) return null
      return children.find(c => Number(c.reply_type) === 2) || children[0]
    },
    mapFollowupReplyNode(node) {
      if (!node) return null
      return {
        id: node.id,
        content: node.content || '',
        images: this.parseImageList(node.images),
        name: node.nickname || '匿名用户',
        avatar: this.resolveDetailAvatar(node.avatar),
        reply_type_text: node.reply_type_text || '追问回复',
        to_nickname: node.to_nickname || ''
      }
    },
    mapAnswerFollowups(answer) {
      const raw = answer.followups || answer.followup_list || answer.follow_up || []
      if (!Array.isArray(raw) || !raw.length) return []
      return raw.map(f => {
        const replyRaw = this.pickFollowupReply(f)
        const hasReply = !!(replyRaw && (replyRaw.content || replyRaw.id))
        return {
          id: f.id,
          content: f.content || '',
          images: this.parseImageList(f.images),
          name: f.nickname || '匿名用户',
          avatar: this.resolveDetailAvatar(f.avatar),
          reply_type_text: f.reply_type_text || '追问',
          to_nickname: f.to_nickname || '',
          has_reply: hasReply || Number(f.has_reply) === 1,
          reply: hasReply ? this.mapFollowupReplyNode(replyRaw) : null
        }
      })
    },
    parseImageList(raw) {
      let paths = []
      if (Array.isArray(raw) && raw.length) {
        paths = raw
      } else if (typeof raw === 'string' && raw) {
        paths = raw.split(',').map(s => s.trim()).filter(Boolean)
      }
      return paths.map(p => (this.$getImageUrl ? this.$getImageUrl(p) : p))
    },
    previewImage(url) {
      this.previewImageUrl = url
      this.showImagePreview = true
    },
    closeImagePreview() {
      this.showImagePreview = false
      this.previewImageUrl = ''
    },
    // 格式化时间戳
    formatTime(timestamp) {
      if (!timestamp) return ''
      const date = new Date(timestamp * 1000)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },
    // 采纳回答
    async adoptedBtn(answer_id) {
      // 检查登录状态
      if (!checkAuth(this.$router, '请先登录后再采纳回答')) {
        return
      }
      try {
        const response = await adoptAnswer({ answer_id })
        if (response && response.code === 1) {
          this.$message.success('采纳成功')
          // 重新获取问题详情以刷新采纳状态
          await this.fetchQuestionDetail(this.currentDetail.id, this.currentDetail.lxval)
        } else {
          this.$message.error(response?.msg || '采纳失败')
        }
      } catch (error) {
        console.error('采纳回答失败:', error)
      }
    },
    // 处理列表中的回复按钮点击
    handleReplyClick(q) {
      if (!this.isCostEngineer) return
      // 点击列表中的回复按钮时，显示详情弹窗
      this.openDetail({ ...q, lxval: '1' })
    },
    showFollowupDialog(answerId) {
      if (!this.isQuestionOwner) return
      if (!checkAuth(this.$router, '请先登录后再追问')) {
        return
      }
      if (!this.currentDetail || !this.currentDetail.id) return
      this.followupDialogMode = 'ask'
      this.followupAnswerId = answerId
      this.followupReplyId = null
      this.followupVisible = true
      this.resetFollowupForm()
    },
    showFollowupReplyDialog(followupId) {
      if (!this.isCostEngineer) return
      if (!checkAuth(this.$router, '请先登录后再回复追问')) {
        return
      }
      if (!this.currentDetail || !this.currentDetail.id) return
      this.followupDialogMode = 'reply'
      this.followupReplyId = followupId
      this.followupAnswerId = null
      this.followupVisible = true
      this.resetFollowupForm()
    },
    resetFollowupForm() {
      this.followupForm = { content: '' }
      this.followupImageFileList = []
      this.followupImageUrls = []
      if (this.$refs.followupFormRef) {
        this.$refs.followupFormRef.resetFields()
      }
    },
    async followupImageUpload(file) {
      return this.customUpload(file)
    },
    onFollowupImageChange(file, fileList) {
      this.followupImageFileList = fileList
      this.followupImageUrls = fileList
        .filter(item => item.status === 'success')
        .map(item => {
          const response = item.response
          if (response && response.url) return response.url
          return item.url
        })
        .filter(Boolean)
    },
    onFollowupImageRemove(file, fileList) {
      this.followupImageFileList = fileList
      this.followupImageUrls = fileList
        .filter(item => item.status === 'success')
        .map(item => {
          const response = item.response
          if (response && response.url) return response.url
          return item.url
        })
        .filter(Boolean)
    },
    async submitFollowup() {
      const isAsk = this.followupDialogMode === 'ask'
      if (isAsk) {
        if (!this.isQuestionOwner || !this.followupAnswerId) return
        if (!checkAuth(this.$router, '请先登录后再追问')) return
      } else {
        if (!this.isCostEngineer || !this.followupReplyId) return
        if (!checkAuth(this.$router, '请先登录后再回复追问')) return
      }
      this.$refs.followupFormRef.validate(async(valid) => {
        if (!valid) return
        this.followupLoading = true
        try {
          const imagesStr = Array.isArray(this.followupImageUrls) && this.followupImageUrls.length
            ? this.followupImageUrls.join(',')
            : ''
          const response = isAsk
            ? await askFollowup({
              question_id: this.currentDetail.id,
              answer_id: this.followupAnswerId,
              content: this.followupForm.content,
              images: imagesStr
            })
            : await replyFollowup({
              question_id: this.currentDetail.id,
              followup_id: this.followupReplyId,
              content: this.followupForm.content,
              images: imagesStr
            })
          if (response && response.code === 1) {
            this.$message.success(response.msg || (isAsk ? '追问成功' : '回复成功'))
            this.followupVisible = false
            await this.fetchQuestionDetail(this.currentDetail.id, this.currentDetail.lxval)
          } else {
            this.$message.error(response?.msg || (isAsk ? '追问失败' : '回复失败'))
          }
        } catch (error) {
          console.error('追问操作失败:', error)
          this.$message.error(isAsk ? '追问失败，请重试' : '回复失败，请重试')
        } finally {
          this.followupLoading = false
        }
      })
    },
    // 显示回复弹窗（用于详情弹窗中的回复按钮）
    showReplyDialog() {
      if (!this.isCostEngineer) return
      // 检查登录状态
      if (!checkAuth(this.$router, '请先登录后再回复问题')) {
        return
      }
      // 详情弹窗中的回复按钮，显示回复弹窗
      if (this.currentDetail && this.currentDetail.id) {
        this.replyVisible = true
        this.resetReplyForm()
      }
    },
    // 重置回复表单
    resetReplyForm() {
      this.replyForm = {
        content: ''
      }
      this.replyImageFileList = []
      this.replyImageUrls = []
      this.replyAttachmentFileList = []
      this.replyAttachmentUrl = ''
      if (this.$refs.replyFormRef) {
        this.$refs.replyFormRef.resetFields()
      }
    },
    // 提交回复
    async submitReply() {
      if (!this.isCostEngineer) return
      // 检查登录状态
      if (!checkAuth(this.$router, '请先登录后再回复问题')) {
        return
      }
      this.$refs.replyFormRef.validate(async(valid) => {
        if (!valid) return

        this.replyLoading = true
        console.log('this.currentDetail', this.currentDetail)

        try {
          const imagesStr = Array.isArray(this.replyImageUrls) && this.replyImageUrls.length
            ? this.replyImageUrls.join(',')
            : ''
          const data = {
            question_id: this.currentDetail.id,
            content: this.replyForm.content,
            images: imagesStr,
            file: this.replyAttachmentUrl || ''
          }

          const response = await answerQuestion(data)
          console.log('response', response)

          if (response && response.code === 1) {
            this.$message.success('回复成功')
            this.replyVisible = false
            // 先刷新问题详情以获取最新的回答数量
            if (this.currentDetail && this.currentDetail.id) {
              await this.fetchQuestionDetail(this.currentDetail.id, this.currentDetail.lxval)
            }
            // 等待一小段时间确保后端数据已更新
            await new Promise(resolve => setTimeout(resolve, 300))
            // 根据当前标签页刷新问题列表（确保回答数量更新）
            if (this.activeTab === 'list') {
              await this.fetchQuestionList()
            } else if (this.activeTab === 'mypost') {
              await this.fetchMyQuestions()
            } else if (this.activeTab === 'myanswer') {
              await this.fetchMyAnswers()
            }
            // 强制更新视图
            this.$forceUpdate()
          } else {
            this.$message.error(response?.msg || '回复失败')
          }
        } finally {
          this.replyLoading = false
        }
      })
    },
    // 处理收藏
    async handleCollect(q) {
      // 检查登录状态
      if (!checkAuth(this.$router, '请先登录后再进行收藏')) {
        return
      }
      if (!q.id) return
      try {
        let res
        if (q.is_collected) {
          // 取消收藏
          res = await cancelFavorite(q.id)
        } else {
          // 收藏
          res = await addFavorite(q.id)
        }
        if (res && res.code === 1) {
          // 更新列表中的收藏状态
          const index = this.questionList.findIndex(item => item.id === q.id)
          if (index !== -1) {
            this.questionList[index].is_collected = !q.is_collected
          }
          this.$message.success(q.is_collected ? '已取消收藏' : '已收藏')
        } else {
          this.$message.error(res?.msg || '操作失败')
        }
      } catch (e) {
        console.error('收藏操作失败:', e)
        this.$message.error('操作失败')
      }
    }
  }
}
</script>

<style scoped>
.costqa-container {
  width: var(--page-container-ratio, 70%);
  height: var(--page-content-height);
  background: #fff;
  border-radius: 10px;
  margin: var(--page-gutter, 20px) auto;
  display: flex;
}

.left-box{
	width: 200px;
	overflow-y: auto;
  }

  .left-box-content{
	background: #ECF2FF;
	height: calc(var(--page-content-height) - 85px);
	border-radius: 0px 10px 0px 10px;
	overflow-y: auto;
	scrollbar-width: none; /* Firefox */
	-ms-overflow-style: none; /* IE and Edge */
  }
  .left-box-content::-webkit-scrollbar { display: none; }
  .left-list-item{
    position: relative;
    height: 60px;
    display: flex;
    align-items: center;
    color: #111111;
    font-size: 18px;
    padding-left: 44px;
    cursor: pointer;
  }
  .left-list-item.active{
    font-weight: 600;
  }
  .left-list-item.active::before{
    content: '';
    position: absolute;
    left: 30px;
    width: 5px;
    height: 20px;
    background: #0F6FE2;
    border-radius: 4px;
  }

  .right-box{
    flex: 1;
    padding: 16px 24px;
  }
  .qa-tabs{
    display: flex;
    align-items: center;
    padding: 12px 0;
  }
  .tab-item{
    height: 44px;
    line-height: 44px;
    padding: 0 20px;
    margin-right: 24px;
    border-radius: 22px;
    background: #F5F7FA;
    color: #606266;
    cursor: pointer;
  }
  .tab-item.active{
    background: #0F6FE2;
    color: #fff;
  }
  .tab-content{
    margin-top: 12px;
    color: #333;
	height: calc(var(--page-content-height) - 100px);
	overflow-y: auto;
	scrollbar-width: none; /* Firefox */
	-ms-overflow-style: none; /* IE and Edge */
  }
  .tab-content::-webkit-scrollbar { display: none; }
  .publish-form .el-form-item{
    margin-bottom: 22px;
  }
  .form-field-wide,
  .upload-block,
  .submit-btn {
    width: 100%;
    max-width: 560px;
  }
  .upload-placeholder{
    width: 146px;
    height: 146px;
    object-fit: contain;
  }

  /* 二级分类标签样式 */
  .sub-tabs{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
    padding: 8px 0 12px;
  }
  .sub-tab-item{
    height: 36px;
    line-height: 36px;
    padding: 0 14px;
    border-radius: 18px;
    background: #F8FAFD;
    color: #606266;
    border: 1px solid #E5E7EB;
    cursor: pointer;
    user-select: none;
  }
  .sub-tab-item:hover{ border-color: #D0D5DC; }
  .sub-tab-item.active{
    background: #0F6FE2;
    border-color: #0F6FE2;
    color: #fff;
  }

  /* 列表卡片 */
  .qa-card{
    background: #fff;
    border-radius: 8px;
    padding: 12px 12px 8px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.06);
    margin-bottom: 16px;
    cursor: pointer;
  }
  .qa-card-header{
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .qa-card-title{ flex: 1; margin: 0 8px; font-weight: 600; color: #303133; }
  .qa-card-right{ color: #909399; font-size: 12px; }
  .qa-card-image img{ width: 100%; border-radius: 6px; margin: 8px 0; }
  .qa-card-footer{ display: flex; justify-content: space-between; color: #909399; font-size: 12px; }
  .qa-card-footer .bounty{ color: #E6A23C; }

  /* 详情 */
  .detail-images{
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin: 8px 0;
  }
  .detail-image-thumb{
    width: 96px;
    height: 96px;
    object-fit: cover;
    border-radius: 6px;
    cursor: pointer;
    transition: opacity 0.2s;
  }
  .detail-image-thumb:hover{
    opacity: 0.85;
  }
  .detail-body{
    max-height: 75vh;
    max-height: 75dvh;
    overflow-y: auto;
  }
  .detail-title{ font-size: 18px; font-weight: 700; color: #303133; margin-bottom: 10px; }
  .detail-section{ margin-top: 10px; }
  .section-title{ font-weight: 600; color: #606266; margin-bottom: 8px;font-size: 18px; }
  .answer-item{  padding: 10px 0; border-bottom: 1px solid #F2F3F5; }
  .answer-item:last-child{ border-bottom: none; }
  .answer-user{ display: flex; align-items: center; gap: 10px; }
  .answer-avatar{ width: 28px; height: 28px; border-radius: 50%; }
  .answer-name{ color: #606266; }
  .answer-actions{ display: flex; align-items: center; gap: 24px; }
  .action-icon{ width: 18px; height: 18px; }
  .adopt, .reject, .followup-reply{ display: inline-flex; align-items: center; gap: 6px; color: #909399; cursor: pointer; }
  .followup-reply:hover{ color: #1E80FF; }
  .adopt.active{ color: #1E80FF; }
  .followup-list{
    margin-top: 12px;
    padding: 12px 12px 4px;
    background: #F7F8FA;
    border-radius: 8px;
  }
  .followup-item{
    padding-bottom: 12px;
    margin-bottom: 12px;
    border-bottom: 1px solid #EBEEF5;
  }
  .followup-item:last-child{
    margin-bottom: 0;
    padding-bottom: 0;
    border-bottom: none;
  }
  .followup-header{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 6px;
  }
  .followup-user{
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 13px;
    color: #909399;
  }
  .followup-avatar{
    width: 22px;
    height: 22px;
    border-radius: 50%;
    object-fit: cover;
  }
  .followup-to{
    color: #C0C4CC;
  }
  .followup-tag{
    display: inline-block;
    font-size: 12px;
    color: #1E80FF;
    background: #E6F4FF;
    padding: 2px 8px;
    border-radius: 4px;
  }
  .followup-tag.reply{
    color: #67C23A;
    background: #F0F9EB;
  }
  .followup-content{
    font-size: 14px;
    color: #606266;
    line-height: 1.6;
    margin-bottom: 6px;
  }
  .followup-reply-block{
    margin-top: 10px;
    padding-top: 10px;
    border-top: 1px dashed #DCDFE6;
  }
  .followup-actions{
    display: flex;
    justify-content: flex-end;
    margin-top: 8px;
    padding-bottom: 8px;
  }
  .reject.active{ color: #909399; }

  /* 我的回答 TabBar */
  .my-tabs{ display: flex; align-items: center; gap: 40px; padding: 6px 0 16px; }
  .my-tab-item{ position: relative; color: #9AA0A6; cursor: pointer; font-size: 16px; }
  .my-tab-item.active{ color: #1E80FF; }
  .my-tab-item.active::after{
    content: '';
    position: absolute;
    left: 0; bottom: -6px;
    width: 100%; height: 3px;
    background: #1E80FF; border-radius: 2px;
  }
  .my-tab-content{ padding-top: 8px; }

  /* 收入样式 */
  .income-card{
    height: 86px;
    border-radius: 10px;
    background: linear-gradient(90deg,#1E80FF 0%, #2EA0FF 100%);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #fff;
    margin-bottom: 16px;
  }
  .income-title{ opacity: 0.9; margin-bottom: 6px; }
  .income-total{ font-size: 28px; font-weight: 700; }
  .income-list-title{ font-weight: 600; color: #303133; margin: 10px 0; }
  .income-item{ display: flex; align-items: center; justify-content: space-between; padding: 10px 4px; border-bottom: 1px solid #F2F3F5; }
  .income-left{ color: #606266; }
  .income-name{ margin-bottom: 2px; }
  .income-time{ font-size: 12px; color: #A0A4AD; }
  .income-amount{ color: #1E80FF; font-weight: 600; }

  /* 加载和提示样式 */
  .loading-text {
    text-align: center;
    color: #999;
    padding: 20px;
    font-size: 14px;
  }

  .form-tip {
    color: #999;
    font-size: 12px;
    margin-top: 4px;
  }

  /* 空状态样式 */
  .empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 60px 20px;
    color: #999;
  }
  .empty-icon {
    font-size: 48px;
    margin-bottom: 16px;
    opacity: 0.6;
  }
  .empty-text {
    font-size: 16px;
    color: #999;
  }

  /* 回复相关样式 */
  .reply-section {
    margin-top: 20px;
    padding-top: 20px;
    border-top: 1px solid #F2F3F5;
    text-align: center;
  }
  .dialog-footer {
    text-align: right;
  }

  /* 我的回答列表样式 */
  .my-answers-list {
    padding: 0;
  }
  .answer-item-card {
    background: #fff;
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 16px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
    border: 1px solid #f0f0f0;
  }
  .answer-card-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 12px;
  }
  .question-title {
    font-size: 16px;
    font-weight: 600;
    color: #303133;
    flex: 1;
    margin-right: 12px;
    line-height: 1.4;
  }
  .adopt-status {
    padding: 4px 8px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 500;
    background: #f5f7fa;
    color: #909399;
    white-space: nowrap;
  }
  .adopt-status.adopted {
    background: #f0f9ff;
    color: #1890ff;
  }
  .answer-content {
    font-size: 14px;
    color: #606266;
    line-height: 1.6;
    margin-bottom: 12px;
  }
  .answer-images {
    display: flex;
    gap: 8px;
    margin-bottom: 12px;
    flex-wrap: wrap;
  }
  .answer-image {
    width: 80px;
    height: 80px;
    object-fit: cover;
    border-radius: 6px;
    border: 1px solid #e4e7ed;
  }
  .answer-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 12px;
    border-top: 1px solid #f0f0f0;
  }
  .answer-info {
    display: flex;
    gap: 16px;
    font-size: 12px;
    color: #909399;
  }
  .reward-amount {
    color: #e6a23c;
    font-weight: 500;
  }
  .like-count {
    color: #67c23a;
  }
  .question-user {
    font-size: 12px;
    color: #909399;
  }

  /* 问答收入样式 */
  .income-question {
    font-size: 12px;
    color: #606266;
    margin: 10px 0;
  }

  /* 我的发布样式 */
  .my-post-list {
    margin-bottom: 20px;
  }

  .my-post-item {
    background: #fff;
    border-radius: 12px;
    padding: 20px;
    margin-bottom: 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    cursor: pointer;
    transition: all 0.3s ease;
    border: 1px solid #f0f0f0;
  }

  .my-post-item:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
    transform: translateY(-2px);
    border-color: #1890ff;
  }

  .post-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 12px;
  }

  .post-title {
    font-size: 18px;
    font-weight: 600;
    color: #333;
    line-height: 1.4;
    flex: 1;
    margin-right: 12px;
  }

  .post-category {
    background: linear-gradient(135deg, #1890ff, #40a9ff);
    color: #fff;
    padding: 4px 12px;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 500;
    white-space: nowrap;
  }

  .post-content {
    font-size: 14px;
    color: #666;
    line-height: 1.6;
    margin-bottom: 16px;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .post-images {
    display: flex;
    gap: 8px;
    margin-bottom: 16px;
    flex-wrap: wrap;
  }

  .post-image {
    width: 80px;
    height: 80px;
    object-fit: cover;
    border-radius: 8px;
    border: 1px solid #f0f0f0;
  }

  .post-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 12px;
    border-top: 1px solid #f0f0f0;
  }

  .post-meta {
    display: flex;
    gap: 16px;
    align-items: center;
  }

  .reward-amount {
    color: #ff4d4f;
    font-weight: 600;
    font-size: 14px;
  }

  .answer-count {
    color: #666;
    font-size: 14px;
  }

  .post-actions {
    display: flex;
    align-items: center;
  }

  .view-detail {
    color: #1890ff;
    font-size: 14px;
    font-weight: 500;
    transition: color 0.3s ease;
  }

  .view-detail:hover {
    color: #40a9ff;
  }

  /* 历史记录样式 */
  .history-list {
    padding: 0;
  }
  .history-item {
    background: #fff;
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 12px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
    border: 1px solid #f0f0f0;
  }
  .history-content {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  .history-title {
    font-size: 16px;
    font-weight: 600;
    color: #303133;
    line-height: 1.4;
  }
  .history-meta {
    display: flex;
    align-items: center;
    gap: 12px;
  }
  .history-type {
    padding: 2px 8px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 500;
    background: #f0f9ff;
    color: #1890ff;
  }
  .history-status {
    padding: 2px 8px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 500;
    background: #f5f7fa;
    color: #909399;
  }
  .history-status.adopted {
    background: #f0f9ff;
    color: #1890ff;
  }
  .history-time {
    font-size: 12px;
    color: #909399;
  }

  .image-preview-mask {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 3000;
  }
  .image-preview-container {
    position: relative;
    max-width: 90vw;
    max-height: 90vh;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .preview-image {
    max-width: 100%;
    max-height: 90vh;
    object-fit: contain;
    border-radius: 8px;
  }
  .preview-close {
    position: absolute;
    right: -40px;
    top: 0;
    width: 30px;
    height: 30px;
    cursor: pointer;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 50%;
    padding: 5px;
  }
  .preview-close:hover {
    background: rgba(255, 255, 255, 0.4);
  }

  @media (max-width: 1600px) {
    .left-list-item {
      font-size: 16px;
      height: 52px;
    }
    .upload-placeholder {
      width: 120px;
      height: 120px;
    }
  }

  @media (max-width: 1366px) {
    .qa-tabs .tab-item {
      height: 38px;
      line-height: 38px;
      padding: 0 14px;
      margin-right: 10px;
      font-size: 14px;
    }
    .detail-title {
      font-size: 16px;
    }
    .section-title {
      font-size: 16px;
    }
  }

  @media (max-height: 800px) {
    .left-list-item {
      height: 46px;
      font-size: 14px;
    }
    .qa-tabs .tab-item {
      height: 36px;
      line-height: 36px;
    }
  }

</style>

